import type {
	LWApiPublicBillingStripePaymentMarkDeclinedParamsRaw,
	LWApiPublicBillingStripePaymentMarkDeclinedResultRaw,
} from '@liquidweb-dev/club-sauce/public/billing/stripe/payment/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useMutation } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * Reports a Stripe confirmation the browser watched fail, so the payment stops
 * sitting in progress until a cleanup job corrects it hours later. Nothing
 * reads the result, nothing is invalidated, and a report that fails is left to
 * that cleanup job rather than shown to a customer who has already been told
 * their card was declined.
 */
const useBillingStripePaymentMarkDeclined = () =>
	useMutation<
		LWApiPublicBillingStripePaymentMarkDeclinedResultRaw,
		ApiErrorI,
		LWApiPublicBillingStripePaymentMarkDeclinedParamsRaw
	>({
		mutationFn: (params) =>
			api.billing.stripe.payment.apiRaw.markDeclined(params),
	});

export default useBillingStripePaymentMarkDeclined;
